import { render, staticRenderFns } from "./AddNewDocument.vue?vue&type=template&id=75ba3290&"
import script from "./AddNewDocument.vue?vue&type=script&lang=js&"
export * from "./AddNewDocument.vue?vue&type=script&lang=js&"
import style0 from "./AddNewDocument.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports